export const mapValuesToDTO = (values) => {
  return {
    id: values.id,
    name: values.name,
    fromDateTime: `${values.fromDate}T00:00:00`,
    toDateTime: `${values.toDate}T00:00:00`,
    gate: values.gate,
    vesselOps: values.vesselOps,
    remarks: values.remarks,
    terminalCode: values.terminalCode,
  };
};

export const parseDate = (isoDate: string) =>
  `${isoDate.substring(8, 10)}/${isoDate.substring(5, 7)}/${isoDate.substring(0, 4)} ${isoDate.substring(11, 16)}`;

export const parseDateOnly = (isoDate: string) =>
  `${isoDate.substring(8, 10)}/${isoDate.substring(5, 7)}/${isoDate.substring(0, 4)}`;
